import './styles/index.scss';
import '../views/sections';
import '../views/blocks';
import '../views/layout';
import '../views/ui';
import './js';

document.addEventListener('DOMContentLoaded', async function () {}, {
  once: true,
});
